import { ApiContextType } from '../api-context';
import {
    FetchRequest,
    FetchMailsResponse, MailTemplate, UpdateMailTemplate
} from '../typings';

export const fetchMailTemplates = (api: ApiContextType, request: FetchRequest): Promise<FetchMailsResponse> => {
    return api.post(`/mails`, request)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchMailTemplate = (api: ApiContextType, id: number): Promise<MailTemplate> => {
    return api.get(`/mail/${id}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const createMailTemplate = (api: ApiContextType, name: string): Promise<number> => {
    return api.put(`/mail`, name)
        .then(res => {
            if (res.status === 200 || res.status === 204) {
                return res.text().then(t => Promise.resolve(Number(t)));
            }
            return Promise.reject(0);
        });
};


export const updateMailTemplate = (api: ApiContextType, id: number, request: UpdateMailTemplate): Promise<void> => {
    return api.post(`/mail/${id}`, request)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const commitMailTemplate = (api: ApiContextType, id: number): Promise<void> => {
    return api.post(`/mail/${id}/commit`)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};

export const testMailTemplate = (api: ApiContextType, id: number, email: string): Promise<void> => {
    return api.post(`/mail/${id}/send`, email)
        .then(res => {
            if (res.status === 200 || res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};


